function SectionSubText({ children, size }) {
    size = size || 'max-w-xl'

    return (
        <div className="mt-6">
            <p className={`text-lg text-center ${size} mx-auto`}>{children}</p>
        </div>
    )
}

export default SectionSubText
